import React from "react";
import { useParams } from "react-router-dom";

import { Card } from "primereact/card";

import CustomeButton from "../../../components/Button/index";
import SearchBar from "../../../components/searchBar/index";

import chainIcon from "../../../assets/images/empty-icon-secondary.png";
import searchIcon from "../../../assets/images/search-icon.png";
import useUserAccess from "../useUserAccess";
import DeleteModal from "./DeleteModal";
import EmptyDataView from "../../../components/nodataview";
import UserAccessDropDown from "../../../components/UserAccessDropDown";
import SuccessNotification from "../../../components/entities/address/SuccessNotification";
import Loader from "../../../components/loader/index";
import AccesTable from "./AccesTable";
import Filter from "../../../components/filter/Filter";
import AuditSidebar from "../../../components/audit-sidebar/AuditSidebar";
import API_ROUTES from "../../../api-routes";

const EntityAccess = () => {
  const { id } = useParams();
  const {
    states,
    handleCloseMenu,
    searchEntity,
    handlSelectedService,
    handleSetMenu,
    handleSelection,
    openDeleteModal,
    closeDeleteModal,
    deleteUserAccess,
    handleSearchAccess,
    paginationOnchange,
    hanleChangeUpdateAccess,
    handleDiscardUpdate,
    setIsAuditSidebarOpen,
    handlTogglePayrollPlus,
    hanleUpdatePayrollPlus,
  } = useUserAccess(id);

  const auditLabels = () => {
    return {
      create: "Entity Added",
      update: "Entity Information Updated",
      delete: "Entity Removed",
    };
  };

  return (
    <>
      <Card className="gen-card h-full entity-access">
        <div className="formgrid grid ">
          <div className=" col-12">
            <p className="profile-heading">Entities & Services</p>
            <p className="profile-para">
              Find all the services and entities linked to your profile
            </p>
          </div>
        </div>
        {states?.successMsg && (
          <SuccessNotification successMsg={states?.successMsg} />
        )}

        <div className="flex flex-wrap justify-between align-items-center gap-2 w-full mt-3 mb-3">
          <div className="flex-1 min-w-[200px]">
            <SearchBar
              placeholder="Search entities by name"
              onChange={(e) => handleSearchAccess(e.target.value)}
            />
          </div>
          <div className="flex gap-2 flex-wrap justify-end">
            <CustomeButton
              label="View History"
              variant="outlined"
              className="mr-2"
              icon="pi pi-history"
              iconPos="right"
              onClick={() => setIsAuditSidebarOpen(true)}
            />
            <CustomeButton
              label="Manage Access"
              icon="pi pi-angle-down"
              variant="contained"
              iconPos="right"
              onClick={(e) => handleSetMenu(e)}
            />
          </div>
        </div>

        <div className="formgrid grid">
          <div className="field col-8 mb-2 mt-3">
            {states?.isLoading ? (
              <div className="formgrid grid">
                <div className="field col-12 mb-2 mt-3">
                  <EmptyDataView
                    Icon={<Loader />}
                    Header={"Adding Selection"}
                    Description={
                      "Please don't close or refresh this page. We are adding your selection"
                    }
                  />
                </div>
              </div>
            ) : states?.useraccesslist?.length > 0 ? (
              <>
                <AccesTable
                  allservices={states?.entityservices}
                  accesslists={states?.useraccesslist}
                  openDeleteModal={openDeleteModal}
                  paginationOnchange={paginationOnchange}
                  paginationFisrt={states?.paginationFisrt}
                  paginationRows={states?.paginationRows}
                  hanleChangeUpdateAccess={hanleChangeUpdateAccess}
                  selectedProcess={states?.selectedProcess}
                  updatEntity={states?.updatEntity}
                  hanleUpdatePayrollPlus={hanleUpdatePayrollPlus}
                />
              </>
            ) : states.searchQuery ? (
              <EmptyDataView
                Icon={
                  <img
                    className="users-card-icon-img"
                    src={searchIcon}
                    alt="Search Icon"
                  />
                }
                Header={"No results found"}
                Description={`We couldn’t find any files or documents matching ${states.searchQuery}. Try refining your search.`}
              />
            ) : (
              <EmptyDataView
                Icon={
                  <img
                    className="users-card-icon-img"
                    src={chainIcon}
                    alt="Users Icon"
                  />
                }
                Header={"No entities or services have been linked yet"}
                Description={
                  "Select entities and manage their access to services."
                }
              />
            )}
          </div>
          <div className="field col-12 mb-2 mt-3">
            {states?.updateBtnAvailbel && (
              <div className="col-12  pb-3">
                <div className="flex justify-content-end mt-3">
                  <CustomeButton
                    label="Discard"
                    variant="outlined"
                    className="mr-2"
                    onClick={handleDiscardUpdate}
                  />
                  <CustomeButton
                    label="Save Update"
                    variant="contained"
                    className="access-btn"
                    onClick={handleSelection}
                    loading={states?.isLoading}
                    disabled={!states?.updatEntity.length > 0}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <UserAccessDropDown
          refPanel={states?.refPanel}
          data={states?.entities}
          entityservices={states?.entityservices}
          handleClose={handleCloseMenu}
          isLoading={states?.isLoading}
          searchEntity={searchEntity}
          handleSelection={handleSelection}
          selectedProcess={states?.selectedProcess}
          handlSelectedService={handlSelectedService}
          handlTogglePayrollPlus={handlTogglePayrollPlus}
        />
      </Card>
      {states?.isAuditSidebarOpen && (
        <AuditSidebar
          heading="Entities & Services"
          endpoint={API_ROUTES.FETCH_USER_AUDIT_ENTITY_ACCESS}
          id={id}
          labels={auditLabels}
          setSidebarToggle={setIsAuditSidebarOpen}
          sidebarToggle={states?.isAuditSidebarOpen}
          endType="USERACCESS"
        />
      )}
      {states?.deletemodal && (
        <DeleteModal
          visible={states?.deletemodal}
          selectedEntity={states?.deleteEntity}
          closeModal={closeDeleteModal}
          deleteUserAccess={deleteUserAccess}
          isLoading={states?.isRemoveLoading}
        />
      )}
    </>
  );
};

export default EntityAccess;
